import * as moment from 'moment';
import * as _ from 'lodash';
import React, { ChangeEvent } from 'react';
import { FormControl, Button, Row, Col, FormGroup, ButtonGroup, ControlLabel, ToggleButtonGroup, ToggleButton, Well, Glyphicon, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { IDonorSearchRequest, IDonorStatus, IListItem } from '@nkr/models/index';
import { ICoordinator } from '../../coordinator';
import { OrganType } from '@nkr/enums/organ-type';
import { useAppHookContext } from '@nkr/utils/rest-api';
import { ISearch } from './list';
import MaskedInput from 'react-maskedinput';

interface IProps {
    centerId: number,
    data: ISearch,
    subSection: string,
    isAdminSection: boolean,
    statusList: IDonorStatus[],
    dispositionList: IListItem[],
    coordinatorList: ICoordinator[],
    referDonorToNkr: boolean,
    onChange: (search: ISearch, refresh: boolean) => void,
    onClearGrid: () => void,
    onSearch: () => void,
    onExport: () => void
}

const Filters = (props: IProps) => {
    const { app: { site } } = useAppHookContext();
    const defaultOrganType = site.organType == OrganType.Kidney ? 0 : 1;

    const update = (name: string, value: any, refresh: boolean) => {
        let search = _.cloneDeep(props.data);

        if (name == 'coordinatorId') {
            search.filters.coordinatorId = parseInt(value);
        } else if (name == 'centerId') {
            search.filters.centerId = parseInt(value);

            if (search.filters.centerId == -1) {
                search.filters.centerId = 0;
            }
        } else if (name == 'disposition') {
            search.filters.disposition = parseInt(value);
        } else if (name == 'isInEmr') {
            search.filters.isInEmr = parseInt(value);
        } else if (name == 'centerStatus') {
            search.filters.centerStatus = parseInt(value);
        } else if (name == 'referralStatus') {
            search.filters.referralStatus = value === '' ? null : parseInt(value);
        } else if (name == 'livingDonorPrioritization') {
            search.filters.livingDonorPrioritization = value;
        } else {
            search.filters[name] = value;
        }

        props.onChange(search, refresh);
    }

    const handleFieldChange = (e: ChangeEvent<FormControl & HTMLInputElement & HTMLSelectElement>) => {
        let { name, value } = e.currentTarget;
        update(name, value, false);
    };

    const handleToggleFilter = (property: string) => {
        update(property, !props.data.filters[property], true);
    };

    const handleNumericChange = (field: string, value: number) => {
        update(field, value, false);
    };

    const handleKeyDownSearchRegistration = (event: React.KeyboardEvent<FormControl & HTMLInputElement>): void => {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            props.onSearch();
        }
    }

    const handleKeyDownAdvancedSearch = (event: React.KeyboardEvent<FormControl & HTMLInputElement>): void => {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            props.onSearch();
        }
    };

    const getBaseFilters = () => {
        let filters: IDonorSearchRequest = {
            centerId: props.centerId,
            firstName: '',
            lastName: '',
            alias: '',
            email: '',
            dateOfBirth: '',
            includeNkr: true,
            includeDash: true,
            includeMiSite: true,
            showFilter: 0,
            dateSearchType: 0,
            // filterStartDate: moment().subtract(12, 'month').format('YYYY-MM-DD'),
            // filterEndDate: moment().format('YYYY-MM-DD'),
            filterStartDate: '',
            filterEndDate: '',
            disposition: -1,
            centerStatus: -1,
            isInEmr: 0,
            coordinatorId: localStorage.getItem('dashCoordinator') != null && localStorage.getItem('dashCoordinator') !== '' ? parseInt(localStorage.getItem('dashCoordinator')) : -1,
            organType: defaultOrganType,
            followUpDays: null,
            isLostInPwl: null,
            stopCommunication: null,
            connectToDonorIsDesired: null,
            referralStatus: null,
            livingDonorPrioritization: false,
            referred: false,
            donated: false,
            includeAllMs: false,
            micrositeRecipientId: null
        };

        return filters;
    }

    const showAdvancedSearch = (e, show: boolean) => {
        e.preventDefault();
        e.stopPropagation();
        let search = _.cloneDeep(props.data);
        search.filters = getBaseFilters();
        search.showAdvancedSearch = show;
        search.showMoreOptions = false;
        props.onChange(search, false);
        props.onClearGrid();
    };

    const toggleMoreOptions = () => {
        let search = _.cloneDeep(props.data);
        search.showMoreOptions = !search.showMoreOptions;
        props.onChange(search, false);
    };

    const handleRemoveLDPriorityFilter = () => {
        update('livingDonorPrioritization', false, true);
    };

    const { organType, coordinatorId, firstName, lastName, alias, email, dateOfBirth, livingDonorPrioritization, dateSearchType,
        filterStartDate, filterEndDate, centerStatus,
        includeDash, includeNkr, includeMiSite,
        showFilter, disposition, connectToDonorIsDesired, referralStatus
    } = props.data.filters;

    const isUniversalDashCenter = props.referDonorToNkr ?? false;

    return (
        <>
            <Well style={{ marginBottom: 5, padding: 10, backgroundColor: '#f5f5f5' }}>
                {props.subSection == 'TO-DO' && (
                    <>
                        <Row>
                            {site.organType == OrganType.Kidney && (
                                <Col xs={6} sm={3}>
                                    <FormGroup bsSize='sm'>
                                        <ControlLabel>Organ:&nbsp;</ControlLabel>
                                        <div>
                                            <ToggleButtonGroup type='radio' name='organType' className='btn-group-justified'>
                                                <ToggleButton value={-1} className={organType === -1 ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={() => handleNumericChange('organType', -1)}>Both</ToggleButton>
                                                <ToggleButton value={0} className={organType === 0 ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={() => handleNumericChange('organType', 0)}>Kidney</ToggleButton>
                                                <ToggleButton value={1} className={organType === 1 ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={() => handleNumericChange('organType', 1)}>Liver</ToggleButton>
                                            </ToggleButtonGroup>
                                        </div>
                                    </FormGroup>
                                </Col>
                            )}
                            {props.coordinatorList?.length > 0 &&
                                <Col xs={6} sm={3}>
                                    <FormGroup bsSize='sm'>
                                        <ControlLabel>Coordinator:&nbsp;</ControlLabel>
                                        <FormControl
                                            componentClass='select'
                                            name='coordinatorId'
                                            value={coordinatorId ?? undefined}
                                            onChange={handleFieldChange}
                                        >
                                            <option value={-1}>- All -</option>
                                            {props.coordinatorList.map((item) =>
                                                <option key={'au-' + item.contactId} value={item.contactId}>{item.fullName}</option>
                                            )}
                                        </FormControl>
                                    </FormGroup>
                                </Col>
                            }
                            <Col xs={6} sm={3}>
                                <FormGroup>
                                    <ControlLabel>&nbsp;</ControlLabel>
                                    <div>
                                        <Button bsStyle='primary' bsSize='sm' onClick={props.onSearch}>Search</Button>
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>
                    </>
                )}

                {props.subSection == 'ALL' && (
                    <Row className='row-margined'>
                        <Col xs={12}>
                            <ul className='nav nav-pills'>
                                <li role='presentation' className={props.data.showAdvancedSearch ? '' : 'active'}><a href='#' style={{ padding: '3px 6px' }} onClick={(e) => showAdvancedSearch(e, false)}>Find Registrant</a></li>
                                <li role='presentation' className={props.data.showAdvancedSearch ? 'active' : ''}><a href='#' style={{ padding: '3px 6px' }} onClick={(e) => showAdvancedSearch(e, true)}>Advanced Search</a></li>
                            </ul>
                        </Col>
                    </Row>
                )}

                {props.subSection == 'ALL' && !props.data.showAdvancedSearch && (
                    <>
                        <Row>
                            <Col xs={6} sm={4}>
                                <FormGroup bsSize='sm'>
                                    <ControlLabel>Organ:&nbsp;</ControlLabel>
                                    <div>
                                        <ToggleButtonGroup type='radio' name='organType' className='btn-group-justified'>
                                            <ToggleButton value={-1} className={organType === -1 ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={() => handleNumericChange('organType', -1)}>Both</ToggleButton>
                                            <ToggleButton value={0} className={organType === 0 ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={() => handleNumericChange('organType', 0)}>Kidney</ToggleButton>
                                            <ToggleButton value={1} className={organType === 1 ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={() => handleNumericChange('organType', 1)}>Liver</ToggleButton>
                                        </ToggleButtonGroup>
                                    </div>
                                </FormGroup>
                            </Col>
                            <Col xs={6} sm={4}>
                                <FormGroup bsSize='sm'>
                                    <ControlLabel>First Name:&nbsp;</ControlLabel>
                                    <FormControl
                                        name='firstName'
                                        value={firstName}
                                        onKeyDown={handleKeyDownSearchRegistration}
                                        onChange={handleFieldChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs={6} sm={4}>
                                <FormGroup bsSize='sm'>
                                    <ControlLabel>Last Name:&nbsp;</ControlLabel>
                                    <FormControl
                                        name='lastName'
                                        value={lastName}
                                        onKeyDown={handleKeyDownSearchRegistration}
                                        onChange={handleFieldChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs={6} sm={4}>
                                <FormGroup bsSize='sm'>
                                    <ControlLabel>Email:&nbsp;</ControlLabel>
                                    <FormControl
                                        name='email'
                                        value={email}
                                        onKeyDown={handleKeyDownSearchRegistration}
                                        onChange={handleFieldChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs={6} sm={4}>
                                <FormGroup bsSize='sm'>
                                    <ControlLabel>DOB:&nbsp;</ControlLabel>
                                    <MaskedInput
                                        name='dateOfBirth'
                                        className='form-control'
                                        mask={'11/11/1111'}
                                        value={moment(dateOfBirth).format('MM/DD/YYYY')}
                                        onKeyDown={handleKeyDownSearchRegistration}
                                        onChange={handleFieldChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs={6} sm={4} className='pull-right'>
                                <FormGroup bsSize='sm'>
                                    <ControlLabel>&nbsp;</ControlLabel>
                                    <Button className='btn-block' bsStyle='primary' onClick={props.onSearch}>Find Registrant</Button>
                                </FormGroup>
                            </Col>
                        </Row>
                    </>
                )}

                {props.subSection == 'ALL' && props.data.showAdvancedSearch && (
                    <>
                        <Row>
                            <Col xs={12} md={6} className='form-inline'>
                                <div className='alert alert-info'>
                                    {livingDonorPrioritization && (
                                        <FormGroup>
                                            <OverlayTrigger
                                                placement='bottom'
                                                overlay={<Tooltip id='tooltip-ld'>This filter is added when coming from the 'Center Performance' report to grab data that meets the criteria on that page. Click this button to remove the filter.</Tooltip>}
                                            >
                                                <Button style={{ marginRight: '5px' }} onClick={handleRemoveLDPriorityFilter}>
                                                    Remove Missing LD Prioritization Filter &nbsp; <Glyphicon style={{ top: '2px' }} glyph='question-sign' />
                                                </Button>
                                            </OverlayTrigger>
                                        </FormGroup>
                                    )}
                                    <FormGroup bsSize='sm'>
                                        <ToggleButtonGroup type='radio' name='dateSearchType'>
                                            <ToggleButton value={0} className={dateSearchType == 0 ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={() => handleNumericChange('dateSearchType', 0)}>Registration Date&nbsp;</ToggleButton>
                                            <ToggleButton value={1} className={dateSearchType == 1 ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={() => handleNumericChange('dateSearchType', 1)}>Referral Date&nbsp;</ToggleButton>
                                            <ToggleButton value={2} className={dateSearchType == 2 ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={() => handleNumericChange('dateSearchType', 2)}>Donation Date</ToggleButton>
                                        </ToggleButtonGroup>
                                    </FormGroup>
                                    <FormGroup bsSize='sm'>
                                        <ControlLabel>&nbsp;Between:&nbsp;</ControlLabel>
                                        <input
                                            type='date'
                                            className='form-control form-control-sm'
                                            style={{ width: 150 }}
                                            name='filterStartDate'
                                            value={moment(filterStartDate).format('YYYY-MM-DD')}
                                            onKeyDown={handleKeyDownAdvancedSearch}
                                            onChange={handleFieldChange}
                                        />
                                    </FormGroup>
                                    <FormGroup bsSize='sm'>
                                        <ControlLabel>&nbsp;and:&nbsp;</ControlLabel>
                                        <input
                                            type='date'
                                            className='form-control form-control-sm'
                                            style={{ width: 150 }}
                                            name='filterEndDate'
                                            value={moment(filterEndDate).format('YYYY-MM-DD')}
                                            onKeyDown={handleKeyDownAdvancedSearch}
                                            onChange={handleFieldChange}
                                        />
                                    </FormGroup>
                                </div>
                            </Col>
                            <Col xs={12} sm={8} md={4}>
                                <FormGroup bsSize='sm'>
                                    <ControlLabel>Registration Status:&nbsp;</ControlLabel>
                                    <div>
                                        <ToggleButtonGroup type='radio' name='referralStatus' className='btn-group-justified'>
                                            <ToggleButton value={-1} className={referralStatus === null || referralStatus === -1 ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={() => handleNumericChange('referralStatus', -1)}>All</ToggleButton>
                                            <ToggleButton value={0} className={referralStatus === 0 ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={() => handleNumericChange('referralStatus', 0)}>Non-Referred</ToggleButton>
                                            <ToggleButton value={1} className={referralStatus === 1 ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={() => handleNumericChange('referralStatus', 1)}>Referred</ToggleButton>
                                            {isUniversalDashCenter && (
                                                <ToggleButton value={2} className={referralStatus === 2 ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={() => handleNumericChange('referralStatus', 2)}>Referred to Other</ToggleButton>
                                            )}
                                        </ToggleButtonGroup>
                                    </div>
                                </FormGroup>
                            </Col>
                            <Col xs={12} sm={4} md={2}>
                                <FormGroup bsSize='sm'>
                                    <ControlLabel>&nbsp;</ControlLabel>
                                    <div>
                                        <Button className='btn-block' bsStyle='primary' onClick={props.onSearch}>Search</Button>
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>
                        {!props.data.showMoreOptions && (
                            <Row className='row-margined'>
                                <Col xs={12}>
                                    <Button bsStyle='success' bsSize='sm' onClick={toggleMoreOptions}>More Options</Button>
                                </Col>
                            </Row>
                        )}
                        {props.data.showMoreOptions && (
                        <Row>
                            {props.coordinatorList?.length > 0 &&
                                <Col xs={1}>
                                    <FormGroup bsSize='sm'>
                                        <ControlLabel>Coordinator:&nbsp;</ControlLabel>
                                        <FormControl
                                            componentClass='select'
                                            name='coordinatorId'
                                            value={coordinatorId}
                                            onChange={handleFieldChange}
                                        >
                                            <option value={-1}>- All -</option>
                                            {props.coordinatorList.map((item) =>
                                                <option key={'au-' + item.contactId} value={item.contactId}>{item.fullName}</option>
                                            )}
                                        </FormControl>
                                    </FormGroup>
                                </Col>
                            }
                            {props.statusList?.length > 0 &&
                                <Col xs={1}>
                                    <FormGroup bsSize='sm'>
                                        <ControlLabel>Workflow Status:&nbsp;</ControlLabel>
                                        <FormControl
                                            componentClass='select'
                                            name='centerStatus'
                                            className='form-control'
                                            value={centerStatus}
                                            onChange={handleFieldChange}
                                        >
                                            <option value={-1}>- All -</option>

                                            {props.statusList != null && (
                                                props.statusList.map((item, index) =>
                                                    <option key={'cs-' + index} value={item.id}>{item.description}</option>
                                                )
                                            )}
                                        </FormControl>
                                    </FormGroup>
                                </Col>
                            }
                            <Col xs={1}>
                                <FormGroup bsSize='sm'>
                                    <ControlLabel>Network Status:&nbsp;</ControlLabel>
                                    <FormControl
                                        componentClass='select'
                                        className='form-control'
                                        name='disposition'
                                        value={disposition}
                                        onChange={handleFieldChange}
                                    >
                                        <option value={-1}>- All -</option>
                                        {props.dispositionList.map((item, index) =>
                                            <option key={'di-' + index} value={item.id}>{item.description}</option>
                                        )}
                                    </FormControl>
                                </FormGroup>
                            </Col>
                            <Col xs={2}>
                                <FormGroup bsSize='sm'>
                                    <ControlLabel>Opt-Out Status:&nbsp;</ControlLabel>
                                    <div>
                                        <ToggleButtonGroup type='radio' name='connectToDonorIsDesired' className='btn-group-justified'>
                                            <ToggleButton value={-1} className={connectToDonorIsDesired === null || connectToDonorIsDesired === -1 ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={() => handleNumericChange('connectToDonorIsDesired', null)}>All</ToggleButton>
                                            <ToggleButton value={0} className={connectToDonorIsDesired === 0 ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={() => handleNumericChange('connectToDonorIsDesired', 0)}>Out</ToggleButton>
                                            <ToggleButton value={1} className={connectToDonorIsDesired === 1 ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={() => handleNumericChange('connectToDonorIsDesired', 1)}>In</ToggleButton>
                                        </ToggleButtonGroup>
                                    </div>
                                </FormGroup>
                            </Col>
                            <Col xs={2}>
                                <FormGroup bsSize='sm'>
                                    <ControlLabel>Source:&nbsp;</ControlLabel>
                                    <div>
                                        <ButtonGroup className='btn-group btn-group-justified'>
                                            <div className='btn-group'>
                                                <Button value='includeDash' className={includeDash ? 'btn-primary btn-sm active' : 'btn-default btn-sm'} onClick={() => handleToggleFilter('includeDash')}>DASH</Button>
                                            </div>
                                            <div className='btn-group'>
                                                <Button value='includeNkr' className={includeNkr ? 'btn-primary btn-sm active' : 'btn-default btn-sm'} onClick={() => handleToggleFilter('includeNkr')}>NKR</Button>
                                            </div>
                                            <div className='btn-group'>
                                                <Button value='includeMiSite' className={includeMiSite ? 'btn-primary btn-sm active' : 'btn-default btn-sm'} onClick={() => handleToggleFilter('includeMiSite')}>MiSite</Button>
                                            </div>
                                        </ButtonGroup>
                                    </div>
                                </FormGroup>
                            </Col>
                            {site.organType == OrganType.Kidney && (
                                <Col xs={2}>
                                    <FormGroup bsSize='sm'>
                                        <ControlLabel>Organ:&nbsp;</ControlLabel>
                                        <div>
                                            <ToggleButtonGroup type='radio' name='organType' className='btn-group-justified'>
                                                <ToggleButton value={-1} className={organType === -1 ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={() => handleNumericChange('organType', -1)}>Both</ToggleButton>
                                                <ToggleButton value={0} className={organType === 0 ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={() => handleNumericChange('organType', 0)}>Kidney</ToggleButton>
                                                <ToggleButton value={1} className={organType === 1 ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={() => handleNumericChange('organType', 1)}>Liver</ToggleButton>
                                            </ToggleButtonGroup>
                                        </div>
                                    </FormGroup>
                                </Col>
                            )}
                            <Col xs={2}>
                                <FormGroup bsSize='sm'>
                                    <ControlLabel>Show:&nbsp;</ControlLabel>
                                    <div>
                                        <ToggleButtonGroup type='radio' name='showFilter' className='btn-group-justified'>
                                            <ToggleButton value={0} className={showFilter === 0 ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={() => handleNumericChange('showFilter', 0)}>All</ToggleButton>
                                            <ToggleButton value={1} className={showFilter === 1 ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={() => handleNumericChange('showFilter', 1)}>Active</ToggleButton>
                                            <ToggleButton value={2} className={showFilter === 2 ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={() => handleNumericChange('showFilter', 2)}>Ruled Out</ToggleButton>
                                        </ToggleButtonGroup>
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>
                        )}
                    </>
                )}
            </Well>
        </>
    );
}

export default Filters;